import { AlertColor } from "@mui/material";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import { GridRowParams } from "@mui/x-data-grid";
import { useState } from "react";

import { CustomersCategoriesProps } from "../../pages/CustomersCategoriesPage";
import { api } from "../../services/api";
import ButtonGeneric from "../ButtonGeneric";
import PreloadButton from "../PreloadButton";
import Toast from "../Toast";
import { ModalDeleteCustomerCategoryStyle } from "./styles";

interface Props {
    openDeleteCustomerCategoryModal: boolean;
    handleCloseDeleteCustomerCategoryModal: () => void;
    selectedRowCustomerCategory: GridRowParams["row"];
    setDataCustomersCategoriesList: (
        values: CustomersCategoriesProps[]
    ) => void;
    dataCustomersCategoriesList: CustomersCategoriesProps[];
}

function ModalDeleteCustomerCategory({
    openDeleteCustomerCategoryModal,
    handleCloseDeleteCustomerCategoryModal,
    selectedRowCustomerCategory,
    setDataCustomersCategoriesList,
    dataCustomersCategoriesList,
}: Props) {
    // toast configs
    const [openToast, setOpenToast] = useState(false);
    function handleCloseToast() {
        setOpenToast(false);
    }
    const [toastRequisitionResult, setToastRequisitionResult] =
        useState<AlertColor>();
    const [textToast, setTextToast] = useState("");

    const [isLoadingButton, setIsLoadingButton] = useState(false);

    function deleteCustomerCategory() {
        setIsLoadingButton(true);
        api.delete(`/customersCategory/${selectedRowCustomerCategory.id}`)
            .then((response) => {
                setOpenToast(true);
                setToastRequisitionResult("success");
                setTextToast(response.data.message);
            })
            .then(() => {
                setTimeout(() => {
                    handleCloseDeleteCustomerCategoryModal();
                    setOpenToast(false);
                    setIsLoadingButton(false);
                }, 2000);
            })
            .then(() => {
                setDataCustomersCategoriesList(
                    dataCustomersCategoriesList.filter(
                        (item: { id: number }) => {
                            return item.id !== selectedRowCustomerCategory.id;
                        }
                    )
                );
            })
            .catch((error) => {
                setOpenToast(true);
                setToastRequisitionResult("error");
                setTextToast(error.response.data.message);
                setIsLoadingButton(false);
            });
    }

    return (
        <Modal
            open={openDeleteCustomerCategoryModal}
            onClose={handleCloseDeleteCustomerCategoryModal}
        >
            <ModalDeleteCustomerCategoryStyle>
                <Box className="modalContainer">
                    <p>{`Deseja excluir a Categoria de Cliente "${selectedRowCustomerCategory.name}"?`}</p>
                    <div className="buttonsContainer">
                        <ButtonGeneric
                            onclick={handleCloseDeleteCustomerCategoryModal}
                            buttonColor="var(--cancel)"
                            text="CANCELAR"
                        />
                        <PreloadButton
                            colorText="white"
                            background="var(--delete)"
                            loading={isLoadingButton}
                            text="DELETAR"
                            type="submit"
                            onClick={() => deleteCustomerCategory()}
                        />
                    </div>
                </Box>
                <Toast
                    open={openToast}
                    onClose={() => handleCloseToast()}
                    severity={toastRequisitionResult}
                    text={textToast}
                />
            </ModalDeleteCustomerCategoryStyle>
        </Modal>
    );
}
export default ModalDeleteCustomerCategory;
